const DIAS_LABEL = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

export default function ResumenSemanal({ dias }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 p-5">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
        Resumen de la semana
      </p>
      <div className="space-y-2">
        {dias.map((dia) => (
          <div key={dia.dia_semana} className="flex items-start gap-3 text-sm">
            <span className="w-20 text-slate-500 font-medium flex-shrink-0">
              {DIAS_LABEL[dia.dia_semana]}
            </span>
            <ResumenDia dia={dia} />
          </div>
        ))}
      </div>
    </div>
  );
}

function ResumenDia({ dia }) {
  if (dia.es_feriado) {
    return (
      <span className="text-red-600 font-medium">
        Feriado{dia.feriado_motivo ? ` — ${dia.feriado_motivo}` : ""}
      </span>
    );
  }

  if (!dia.activo) {
    return <span className="text-slate-400 italic">No laboral</span>;
  }

  const franjas =
    dia.franjas_horarias.length > 0
      ? dia.franjas_horarias.map((f) => `${f.inicio}–${f.fin}`).join(", ")
      : "Horario libre";

  const coberturas =
    dia.coberturas_habilitadas.length > 0
      ? dia.coberturas_habilitadas.join(", ")
      : "Sin coberturas";

  return (
    <span className="text-slate-700">
      <span className="font-medium text-slate-800">{franjas}</span>
      <span className="text-slate-400 mx-1">·</span>
      <span className="text-slate-500">{coberturas}</span>
    </span>
  );
}
